import { useQuery } from 'react-query'
import { datadogRum } from '@datadog/browser-rum'
import { TAlertProps } from '@/hooks/useSnackBar'
import { useAxios } from '@/axios/config'
import { ApiResponse } from '../types'

export const PAYMENT_METHODS_QUERY_KEY = 'paymentMethods'

interface IUseFetchPaymentMethodProps {
  showAlert: (data: Omit<TAlertProps, 'open'>) => void
}

export function useFetchPaymentMethod({
  showAlert,
}: IUseFetchPaymentMethodProps) {
  const [{ loading: axiosLoading }, executeRequest] = useAxios({
    url: '/v1/admin/payments',
    method: 'GET',
  })
  const fetchPaymentMethodData = async (): Promise<ApiResponse> => {
    const { data } = await executeRequest()
    return data
  }

  const { data, isLoading, error, refetch } = useQuery<ApiResponse, Error>(
    PAYMENT_METHODS_QUERY_KEY,
    fetchPaymentMethodData,
    {
      refetchOnWindowFocus: false,
      onError: (err: Error) => {
        datadogRum.addError(err)
        showAlert({
          message: 'Failed to fetch payment method information',
          severity: 'error',
        })
      },
    }
  )

  return {
    data,
    isLoading,
    error,
    refetch,
    axiosLoading,
  }
}
